/* istanbul ignore file */
import React, { useState, useEffect } from 'react';
import { TextField, useFieldHelper, FieldProps } from 'framework/ui/field';
import { useTechnologyService } from 'domain/shared/career';

interface EmployeeTechnologyFieldProps extends FieldProps {
  allowEmptySpace?: boolean;
}

const EmployeeTechnologyField = (props: EmployeeTechnologyFieldProps) => {
  const { allowEmptySpace, ...rest } = props;
  const { findById } = useTechnologyService();
  const { getValue } = useFieldHelper(props);
  const [displayedValue, setDisplayedValue] = useState<Nullable<string>>(null);

  useEffect(() => {
    (async () => {
      const technology = await findById(getValue());
      setDisplayedValue(technology.name);
    })();
  });

  const fallback = allowEmptySpace ? ' ' : undefined;

  return <TextField {...rest} value={displayedValue ?? fallback} />;
};

export default EmployeeTechnologyField;
